/**
 * Custom hook to sync investor authentication data with Redux store
 */

import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { hydrateInvestorAuth } from "../features/auth/authSlice_Investor";

export interface InvestorAuthData {
  agreedToMembershipAgreement?: boolean;
  orgName?: string;
  agreedToSpvMembershipAgreement?: boolean;
  hasCreditLimit: boolean;
  isAuthRep?: boolean;
  isAdminAuthRep?: boolean;
  entityType?: string;
  userId: number;
  userEmail: string;
  spvStatus?: string;
  spvName?: string;
  pendingOnBoardingAs?: string;
  role?: string;
  organization?: number;
  currentOrgRoleId: number;
  firstName?: string | null;
  lastName?: string | null;
  spvDetails?: any | null;
  regtankOnboardingFeatureFlag?: boolean;
  regtankLivenessFeatureFlag?: boolean;
  regtankRequest?: any;
  regtankLiveness?: any | null;
  regtankOnboarding?: any;
  declarationAISubmitted?: boolean;
}

/**
 * Hook to sync investor authentication data to Redux store
 * Uses single bulk hydration action for optimal performance
 */
export const useInvestorAuthSync = () => {
  const dispatch = useDispatch();

  /**
   * Sync all investor auth data to Redux store using single dispatch
   */
  const syncInvestorAuthToRedux = useCallback(
    (data: InvestorAuthData) => {
      // Single dispatch call
      dispatch(hydrateInvestorAuth(data));
    },
    [dispatch]
  );

  return { syncInvestorAuthToRedux };
};
